import { IndicatorActionTypes } from './indicator.types';

const INITIAL_STATE = {
  roomsIndicators: [],
  usersIndicators: null,
  ticketsIndicators: null,
  ticketsUsersIndicators: null,
  teamIndicators: null,
  errorMessage: undefined,
};

const indicatorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IndicatorActionTypes.FETCH_ROOMS_INDICATORS:
      return {
        ...state,
        roomsIndicators: action.payload,
      };
    case IndicatorActionTypes.FETCH_USERS_INDICATORS:
      return {
        ...state,
        usersIndicators: action.payload,
      };
    case IndicatorActionTypes.FETCH_TICKETS_INDICATORS:
      return {
        ...state,
        ticketsIndicators: action.payload,
      };
    case IndicatorActionTypes.FETCH_TICKETS_USERS_INDICATORS:
      return {
        ...state,
        ticketsUsersIndicators: action.payload,
      };
    case IndicatorActionTypes.FETCH_TEAM_INDICATORS:
      return {
        ...state,
        teamIndicators: action.payload,
      };
    default:
      return state;
  }
};

export default indicatorReducer;